import type { FaireProductEntity } from "../../entity_types/product";

export const p_7aj8n8fwkr: FaireProductEntity = {
  token: "p_7aj8n8fwkr",
  type: "product",
  name: "Virelle 18K Gold Vintage Knot Ring",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/11eee3f088e53e65c24d9b82942641a333af544e6847dead6b78fc2b38ee17fa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/303a9c82ff9df27334ce41990224d843363db70bf12d31cb5791134b40aac849.jpeg",
    "https://cdn.faire.com/fastly/7ad2623c7de3b039472a5a36a4129a22101d461fe6d7ec69fbc2287e58aeeda9.jpeg",
  ],
  priceDollars: 5.93,
  description:
    "18K Gold Vintage Knot Ring\n18K Gold Plating \nYellow Brass \nSize 7 Measurement: 0.682 Diameter/2.14 Circumference\n \n- Nickel-free, Lead-safe",
  tags: [],
  msrpDollars: 19.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:09.261Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
